import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { SinglePanelLayout } from '../../Components';
import { useExtendedTranslation } from '../../Services/i18nService';
import useClinicConfig from '../../Hooks/useClinicConfig';

function LinkEnd() {
  const t = useExtendedTranslation();
  const clinicConfig = useClinicConfig();
  return (
    <SinglePanelLayout logo={clinicConfig.logoName}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h5" color="primary" align="center">
            {t('linkend.header')}
          </Typography>
        </Grid>
      </Grid>
    </SinglePanelLayout>
  );
}

export default LinkEnd;
